import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "sprout-ui-primitives";
import { useCallback } from "react";
import RenderIfChildExists from "@sprout/client-components/dist/RenderIfChildExists";
import styled from "styled-components";
import { getItemUrl } from "sprout-lib";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useHistory } from "react-router";
import PostPageNavigationBreadcrumbs from "./PostPageNavigationBreadcrumbs";
import { layoutPadding } from "./styles";
const PostPageHeaderWrapper = styled(Flex)`
  ${layoutPadding};

  > * + * {
    margin-top: 16px;
  }

  > *:last-child {
    margin-bottom: 24px;
  }
`;
const PostPageHeaderMetaWrapper = styled(Flex)`
  > * {
    margin-bottom: 8px;
  }

  > * + *:not(:last-child) {
    margin-right: 8px;
  }

  > *:first-child + * {
    margin-left: 8px;
  }
`;
const PostPageHeader = (props)=>{
    const { owner , breadcrumbsList , appendMeta , append , next , previous  } = props;
    const history = useHistory();
    useActionRegistryGlobalHandler([
        "PREVIOUS",
        "NEXT"
    ], useCallback((_items, _event, command)=>{
        const target = command === "PREVIOUS" ? previous : next;
        if (!target) return false;
        history.replace(getItemUrl(target));
        return true;
    }, [
        next,
        previous,
        history
    ]));
    return /*#__PURE__*/ _jsxs(PostPageHeaderWrapper, {
        as: "header",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ _jsxs(RenderIfChildExists, {
                component: /*#__PURE__*/ _jsx(PostPageHeaderMetaWrapper, {
                    maxWidth: "100%",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    mb: -1
                }),
                children: [
                    breadcrumbsList && owner && /*#__PURE__*/ _jsx(PostPageNavigationBreadcrumbs, {
                        owner: owner,
                        breadcrumbsList: breadcrumbsList
                    }),
                    appendMeta
                ]
            }),
            append
        ]
    });
};
export default PostPageHeader;
